/**
 * Sanitizes HTML input to prevent XSS attacks
 */
export const sanitizeHtml = (input: string): string => {
  if (!input) return '';

  // Basic HTML entity encoding
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
};

/**
 * Sanitizes text input by limiting length
 */
export const sanitizeText = (input: string, maxLength: number = 1000): string => {
  if (!input) return '';

  return input.slice(0, maxLength);
};

/**
 * Validates and sanitizes numeric input
 */
export const sanitizeNumber = (input: string | number): number | null => {
  if (typeof input === 'number') return input;

  const cleaned = String(input).replace(/[^0-9.-]/g, '');
  const parsed = parseFloat(cleaned);

  return isNaN(parsed) ? null : parsed;
};

/**
 * Validates email format
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Sanitizes currency code
 */
export const sanitizeCurrency = (currency: string): string => {
  return currency.replace(/[^A-Z]/g, '').slice(0, 3);
};
